export default __webpack_public_path__ + "static/media/shared-earth-icons-11.faaa923a.svg";